import sbjs from "sourcebuster";

export const INITIAL_UTM_LOCAL_STORAGE_KEY = "initial_utm_marks";

export function getUTMs(): Record<string, string> {
  try {
    return {
      traffic_type: sbjs.get.current.typ || "",
      utm_source: sbjs.get.current.src || "",
      utm_medium: sbjs.get.current.mdm || "",
      utm_campaign: sbjs.get.current.cmp || "",
      utm_term: sbjs.get.current.trm || "",
      utm_content: sbjs.get.current.cnt || "",
    };
  } catch {
    return {};
  }
}

const setInitialUTM = () => {
  if (!localStorage.getItem(INITIAL_UTM_LOCAL_STORAGE_KEY)) {
    localStorage.setItem(
      INITIAL_UTM_LOCAL_STORAGE_KEY,
      JSON.stringify(getUTMs()),
    );
  }
};

export function initSourceBuster() {
  sbjs.init({
    callback: () => {
      setInitialUTM();
    },
  });
}

export function getInitialAnalyticsData() {
  const initData = localStorage.getItem(INITIAL_UTM_LOCAL_STORAGE_KEY);

  return initData ? (JSON.parse(initData) as Record<string, string>) : null;
}
